import gsap from "gsap";
import { useState, useRef, useEffect } from "react";
import { useGSAP } from "@gsap/react";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import "./introVideo.css";

gsap.registerPlugin(useGSAP);
gsap.registerPlugin(ScrollTrigger);

export default function IntroVideo() {
  // const location = useLocation();

  const [player, setPlayer] = useState(null);
  const [isDark, setIsDark] = useState(false);
  const [videoTitleColor, setVideoTitleColor] = useState("white");

  const imageRef = useRef(null);
  const [scrollPosition, setScrollPosition] = useState(0);

  const isDesktop = window.matchMedia("(min-width: 768px)").matches;

  // useEffect(() => {
  //   if (location.hash) {
  //     const element = document.querySelector(location.hash);
  //     console.log('element', element)
  //     if (element) {
  //       element.scrollIntoView({ behavior: "smooth" });
  //     }
  //   }
  // }, [location]);

  useEffect(() => {
    const tag = document.createElement('script');
    tag.src = 'https://www.youtube.com/iframe_api';
    const firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

    window.onYouTubeIframeAPIReady = () => {
      const newPlayer = new window.YT.Player('videoPlayer', {
        videoId: 'PLf44BXd0SE',
        events: {
          'onReady': (event) => {
            const ytPlayer = event.target;
            setPlayer(ytPlayer);
            // setPlayer(event.target);
            ytPlayer.setPlaybackQuality('tiny');
          },
          'onStateChange': onPlayerStateChange
        },
      });
    };

    return () => {
      window.onYouTubeIframeAPIReady = undefined;
    };
  }, []);

  const onPlayerStateChange = (event) => {
    if (event.data === window.YT.PlayerState.PLAYING) {
      // setIsDark(true);
    } else if (event.data === window.YT.PlayerState.PAUSED || event.data === window.YT.PlayerState.ENDED) {
      // setIsDark(false);
    }
  };

  const togglePlayPause = (position) => {

    // console.log('position', position)

    if (isDesktop) {
      if (position === "in") {
        setIsDark(true);
        setVideoTitleColor("black")
      } else {
        setIsDark(false);
        setVideoTitleColor("white")
      }
    }

    if (player) {
      const playerState = player.getPlayerState();
      if (playerState === window.YT.PlayerState.PLAYING) {
        // console.log('1')
        player.pauseVideo();
      } else if (playerState === window.YT.PlayerState.PAUSED || playerState === window.YT.PlayerState.ENDED) {
        // console.log('2')
        if (position !== "out") {
          // player.playVideo();
        }
      }
    }
  };


  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            togglePlayPause("in");
          } else {
            togglePlayPause("out");
            handleFullscreenEnter()
          }
        });
      },
      { threshold: 0.5 }
    );

    if (imageRef.current) {
      observer.observe(imageRef.current);
    }

    return () => {
      if (imageRef.current) {
        observer.unobserve(imageRef.current);
      }
    };
  }, [player]);

  const saveScrollPosition = () => {
    // console.log('window.scrollY', window.scrollY)
    setScrollPosition(window.scrollY);
  };

  const restoreScrollPosition = () => {
    const rect = imageRef.current.getBoundingClientRect();
    const scrollTop = window.scrollY + rect.top;
    window.scrollTo(0, scrollTop);
  };

  useEffect(() => {
    document.addEventListener('fullscreenchange', restoreScrollPosition);
    document.addEventListener('webkitfullscreenchange', restoreScrollPosition);
    document.addEventListener('mozfullscreenchange', restoreScrollPosition);
    document.addEventListener('MSFullscreenChange', restoreScrollPosition);

    return () => {
      document.removeEventListener('fullscreenchange', restoreScrollPosition);
      document.removeEventListener('webkitfullscreenchange', restoreScrollPosition);
      document.removeEventListener('mozfullscreenchange', restoreScrollPosition);
      document.removeEventListener('MSFullscreenChange', restoreScrollPosition);
    };
  }, [scrollPosition]);

  const handleFullscreenEnter = () => {
    saveScrollPosition();
  };

  return (
    <div>
      <div className="sectionLast">
        <div>
          <p style={{ color: videoTitleColor }}>Next generation CarPlay as introduced in</p>
          <p style={{ color: videoTitleColor }}>WWDC24</p>
        </div>
      </div>
      <div className="image-container" ref={imageRef} id="introVideo"
        onClick={togglePlayPause}
      >


        <div className={`dark-overlay ${isDark ? 'active' : ''}`}></div>
        <div className="centered-image">
          <iframe
            id="videoPlayer"
            width="1280"
            height="720"
            src="https://www.youtube.com/embed/PLf44BXd0SE?enablejsapi=1&autoplay=0&mute=0&controls=0&modestbranding=1&rel=0&start=149"
            // src="https://www.youtube.com/embed/PLf44BXd0SE?si=EFSHrS2YEC0dfUMA&amp;start=149"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
          ></iframe>

        </div>
      </div>
    </div>
  );
}

// ytp-gradient-top
// ytp-chrome-top ytp-show-cards-title